import styled from 'styled-components';

const slideWidth = '800px';

export default styled.div`
  max-width: ${slideWidth};
  margin: 0 auto;
`;
